<script setup>
import { ref } from 'vue';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  title: { type: String, default: '' },
  description: { type: String, default: '' },
});

const isOpen = ref(false);

const open = () => {
  isOpen.value = true;
};
const close = () => {
  isOpen.value = false;
};

useKeyboardEvents({
  Escape: {
    action: () => {
      if (isOpen.value) close();
    },
    allowOnFocusedInput: true,
  },
});

defineExpose({ open, close });
</script>

<template>
  <transition
    enter-active-class="transition duration-200 ease-out"
    enter-from-class="ltr:translate-x-full rtl:-translate-x-full opacity-0"
    leave-active-class="transition duration-150 ease-in"
    leave-to-class="ltr:translate-x-[30%] rtl:-translate-x-[30%] opacity-0"
  >
    <div
      v-if="isOpen"
      class="fixed inset-y-0 ltr:right-0 rtl:left-0 z-50 flex flex-col w-[30rem] max-w-full h-full bg-n-surface-2 ltr:border-l rtl:border-r border-n-weak shadow-lg overflow-auto"
    >
      <div class="flex items-center justify-between px-8 pt-8 pb-2">
        <div class="flex items-center gap-1">
          <div>
            <h2 v-if="title" class="text-lg font-medium text-n-slate-12 mb-1">
              {{ title }}
            </h2>
            <p v-if="description" class="text-sm text-n-slate-11 mb-0">
              {{ description }}
            </p>
          </div>
          <slot name="header-action" />
        </div>
        <Button icon="i-lucide-x" slate ghost sm @click="close" />
      </div>
      <div class="flex flex-col w-full px-8 pt-2 pb-8">
        <slot />
      </div>
    </div>
  </transition>
</template>
